import React, { Component } from 'react';
import {
  Card,
  CardContent,
  Divider,
  Typography,
  Grid
} from '@mui/material';
import Nav_bar from '../../Home/Container/navCon'
import Footer from './footer'
class Faq extends Component {
  render() {
    return (
      <>
      <Nav_bar/>
      <div style={{ padding: '20px', textAlign: 'center', marginTop: '20px' }}>
        <Typography variant="h4" gutterBottom>
          Frequently Asked Questions
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={6}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <Card sx={{ padding: '20px' }}>
                <CardContent>
                  <Typography gutterBottom sx={{ fontSize: 24, fontFamily: 'sans-serif', fontWeight: 'bold', color: '#8D85F1' }}>
                    Question 1: Is QR Code free?
                  </Typography>
                  <Divider /><br />
                  <Typography variant="body2" color="grey" textAlign="justify">
                    <b>ans:</b> &nbsp; Service absolutely free, but after a scan, we will show advertisements (Google Ads). To remove advertisements and get more statistics, you can buy our premium account.
                  </Typography>
                </CardContent>
              </Card>
              <Card sx={{ padding: '20px' }}>
                <CardContent>
                  <Typography gutterBottom sx={{ fontSize: 24, fontFamily: 'sans-serif', fontWeight: 'bold', color: '#8D85F1' }}>
                    Question 2: What kind of information can be stored in QR Code?
                  </Typography>
                  <Divider /><br />
                  <Typography variant="body2" color="grey" textAlign="justify">
                    <b>ans:</b> &nbsp; QR Codes are so versatile, they are able to store a variety of information depending on your needs. It can store a URL to make it easier for you to open a page on the web with just a scan. It can also store contact details so that you don’t have to manually type the name, phone number, and email address to save it to your phone.
                  </Typography>
                </CardContent>
              </Card>
            </div>
          </Grid>
          <Grid item xs={12} md={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img
              src="https://img.freepik.com/free-vector/pay-by-smart-phone-wallet-transaction-sending-digital-money-money-transferring-digitally-from-one-mobile-phone-another-vector-flat-illustration_1150-58768.jpg"
              alt="FAQ Illustration"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Grid>
        </Grid>
      </div>
      <Footer/>
      </>
    );
  }
}

export default Faq;
